export const TRACKING_IDS = {
  leaseStartDate: 'lease_start_date',
  leaseEndDate: 'lease_expiration_date',
  leaseExecutionDate: 'lease_execution_date',
  leaseOccupancyDate: 'lease_occupancy_date',
  isASublease: 'is_sublease',
  propertyName: 'property_name',
  country: 'country',
  address: 'address',
  city: 'city',
  stateName: 'state_province',
  zip: 'zip',
  isWholeBuilding: 'is_whole_building',
  propertyType: 'property_type_subtype',
  parcelSize: 'parcel_size',
  isListedByCBRE: 'is_listed_by_cbre',
  suite: 'suite',
  floorChange: 'floor_number',
  squareFeet: 'square_footage',
  tenantCompanyName: 'org_name',
  tenantCountryName: 'country',
  tenantAddressLine1: 'address',
  tenantAddressLine2: 'address2',
  tenantCity: 'city',
  tenantStateName: 'state_province',
  tenantZip: 'zip',
  tenantPOCFirstName: 'contact_first_name',
  tenantPOCLastName: 'contact_last_name',
  tenantPOCEmail: 'contact_email',
  tenantPOCPhone: 'contact_phone',
  tenantPOCJobTitle: 'contact_title',
  landlordCompanyName: 'org_name',
  landlordCountryName: 'country',
  landlordAddressLine1: 'address',
  landlordAddressLine2: 'address2',
  landlordCity: 'city',
  landlordStateName: 'state_province',
  landlordZip: 'zip',
  landlordPOCFirstName: 'contact_first_name',
  landlordPOCLastName: 'contact_last_name',
  landlordPOCEmail: 'contact_email',
  landlordPOCPhone: 'contact_phone',
  landlordPOCJobTitle: 'contact_title',
  tenantRepresentCompany: 'tenant_represented_by',
  tenantRepresentAgent: 'tenant_represented_by_agent',
  landlordRepresentCompany: 'landlord_represented_by',
  landlordRepresentAgent: 'landlord_represented_by_agent',
  baseRent: 'base_rent',
  freeRent: 'free_rent',
  leaseEscalation: 'rent_escalation_is_custom',
  customLeaseEscalation: 'rent_escalation_custom',
  fixedLeaseEscalation: 'rent_escalation_dollar',
  fixedLeaseEscalationPercent: 'rent_escalation_percent',
  tenantImprovementAllowance: 'tenant_improvement_allowance_amount_per_sqft',
  parkingRatio: 'parking_ratio',
  tenantImprovementDetails: 'tenant_improvements_detail',
  considerationIsPercent: 'considerations_is_percent',
  customConsideration: 'rent_schedule',
};

export const PARENT_KEYS = {
  leaseStartDate: 'lease_info',
  leaseEndDate: 'lease_info',
  leaseExecutionDate: 'lease_info',
  leaseOccupancyDate: 'lease_info',
  isASublease: 'lease_info',
  propertyName: 'lease_info',
  country: 'lease_info',
  address: 'lease_info',
  city: 'lease_info',
  stateName: 'lease_info',
  zip: 'lease_info',
  isWholeBuilding: 'lease_info',
  propertyType: 'lease_info',
  parcelSize: 'lease_info',
  isListedByCBRE: 'lease_info',
  suite: 'lease_info',
  floorChange: 'lease_info',
  squareFeet: 'lease_info',
  tenantCompanyName: 'tenant_buyer_info',
  tenantCountryName: 'tenant_buyer_info',
  tenantAddressLine1: 'tenant_buyer_info',
  tenantAddressLine2: 'tenant_buyer_info',
  tenantCity: 'tenant_buyer_info',
  tenantStateName: 'tenant_buyer_info',
  tenantZip: 'tenant_buyer_info',
  tenantPOCFirstName: 'tenant_buyer_info',
  tenantPOCLastName: 'tenant_buyer_info',
  tenantPOCEmail: 'tenant_buyer_info',
  tenantPOCPhone: 'tenant_buyer_info',
  tenantPOCJobTitle: 'tenant_buyer_info',
  landlordCompanyName: 'landlord_seller_info',
  landlordCountryName: 'landlord_seller_info',
  landlordAddressLine1: 'landlord_seller_info',
  landlordAddressLine2: 'landlord_seller_info',
  landlordCity: 'landlord_seller_info',
  landlordStateName: 'landlord_seller_info',
  landlordZip: 'landlord_seller_info',
  landlordPOCFirstName: 'landlord_seller_info',
  landlordPOCLastName: 'landlord_seller_info',
  landlordPOCEmail: 'landlord_seller_info',
  landlordPOCPhone: 'landlord_seller_info',
  landlordPOCJobTitle: 'landlord_seller_info',
  tenantRepresentCompany: 'comp_info',
  tenantRepresentAgent: 'comp_info',
  landlordRepresentCompany: 'comp_info',
  landlordRepresentAgent: 'comp_info',
  baseRent: 'comp_info',
  freeRent: 'comp_info',
  leaseEscalation: 'comp_info',
  customLeaseEscalation: 'comp_info',
  fixedLeaseEscalation: 'comp_info',
  fixedLeaseEscalationPercent: 'comp_info',
  tenantImprovementAllowance: 'comp_info',
  parkingRatio: 'comp_info',
  tenantImprovementDetails: 'comp_info',
  considerationIsPercent: 'consideration_info',
  customConsideration: 'consideration_info',
};
